import { Expose } from "class-transformer";
import type { GenderEnum } from "../../../../../types/persona/constants/gender.enum";
import type { IPersonaUpsertDto } from "./persona-upsert.dto.interface";

export class PersonaUpsertDto implements IPersonaUpsertDto {
  @Expose()
  firstName?: string;

  @Expose()
  lastName?: string;

  @Expose()
  taxCode?: string;

  @Expose()
  birthDate?: string;

  @Expose()
  birthPlace?: string;

  @Expose()
  gender?: GenderEnum;

  @Expose()
  citizenship?: string[];

  @Expose()
  residencePermitType?: string;

  @Expose()
  registeredCountry?: string;

  @Expose()
  registeredMunicipality?: string;

  @Expose()
  registeredCountryAsCurrent?: boolean;

  @Expose()
  currentCountry?: string;

  @Expose()
  currentMunicipality?: string;

  @Expose()
  currentAddressType?: string;

  @Expose()
  maritalStatus?: string;
}
